/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { ProgressionStep } from "./ProgressionStep";
import type { UserProgressionProgress } from "./UserProgressionProgress";
import type { UserProgressionStateModelMetadata } from "./UserProgressionStateModelMetadata";
import type { UserProgressionStatus } from "./UserProgressionStatus";

export interface UserProgressionStateModel {
  /** Unique progression instance ID */
  id: string;
  /** ID of the user */
  user_id: string;
  /** Key into the PROGRESSION_FLOWS dict */
  flow_name: string;
  /** Current status of the progression */
  status: UserProgressionStatus;
  /** The step ID currently active, None if completed */
  current_step?: ProgressionStep | null;
  /** Full ordered list of step IDs */
  steps: ProgressionStep[];
  /** Ordered list of completed step IDs */
  completed_steps?: ProgressionStep[];
  /** Flow-specific metadata */
  metadata?: UserProgressionStateModelMetadata;
  /** The conversation this progression operates within */
  conversation_id?: string | null;
  /** The clinic request this progression serves; None for flows that escalate without one */
  clinic_request_id?: string | null;
  readonly progress: UserProgressionProgress;
}
